import React from 'react';
import DocumentDetails from './DocumentDetails';

function DocumentsForm() {
  return (
    <DocumentDetails />
  );
}

export default DocumentsForm;
